<template>
  <h1>Team {{ name }} bearbeiten</h1>
  <hr />
  <Form
    class="form-horizontal"
    @submit="save"
    v-if="team.id"
    :initialValues="team"
  >
    <TeamForm :disableStartDate="true"></TeamForm>
    <LoadingButton class="btn-primary" :loading="loading"
      >Speichern</LoadingButton
    >
  </Form>
</template>

<script>
import TeamForm from "@/components/TeamForm.vue";
import teamService from "@/services/team.service.js";
import { mapActions } from "pinia";
import { useAlertsStore } from "@/stores/alerts.js";
import moment from "moment";
import { Form } from "vee-validate";
import LoadingButton from "@/components/LoadingButton.vue";
import { setErrors } from "@/helper/ErrorToActions.js";
import * as Sentry from '@sentry/vue';

export default {
  name: "UpdateTeamView",
  // eslint-disable-next-line vue/no-reserved-component-names
  components: { TeamForm, Form, LoadingButton },
  data() {
    return {
      team: { description: "" },
      name: "",
      loading: false,
    };
  },
  async beforeRouteEnter(to, from, next) {
    let team = { description: "" };
    try {
      let response = await teamService.get(to.params.event, to.params.team);
      team = response.data;
      team.start_date = moment(team.start_date).format("YYYY-MM-DDTHH:mm");
    } catch (e) {
      if (e) {
        Sentry.captureException(e);
        useAlertsStore.addAlert(
          "danger",
          "Es ist was unerwartetes schief gegangen.."
        );
        window.scrollTo(0, 0);
      }
    }
    for (let i = 0; i < team.teamleads.length; i++) {
      team.teamleads[i] = team.teamleads[i].id;
    }
    next((vm) => {
      vm.name = team.name;
      vm.team = team;
      console.log(vm.team);
    });
  },
  methods: {
    ...mapActions(useAlertsStore, { addAlert: "add" }),
    async save(team, actions) {
      this.loading = true;
      try {
        let data = {
          name: team.name,
          description: team.description,
          teamleads: team.teamleads,
        };
        await teamService.update(this.$route.params.event, this.team.id, data);
        this.addAlert("success", "Team erfolgreich bearbeitet");
        this.$router.push({
          path: "/teams",
          query: { event_id: this.$route.params.event },
        });
      } catch (e) {
        if (e) {
          if (e.response.data && e.response.data.errors) {
            setErrors(e.response.data.errors, actions);
            this.loading = false;
            return;
          }
          Sentry.captureException(e);
          this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
